import { TaxRetentions } from "components";

export function HistoricRetentions({partnerId}: {partnerId: number}) {
  return (
    <div>
      <h1 style={{ fontSize: "1.5rem" }}>Búsqueda de certificados</h1>

      <TaxRetentions
        showPeriodicity
        itemsPerPage={50}
        partnerId={partnerId}
        // defaultStatus="ISSUED"
        // statusFilter={[
        //   { text: "Emitido", value: "ISSUED" },
        //   { text: "Cancelado", value: "CANCELLED" },
        // ]}
      />
    </div>
  );
}
